import SeoFlightResult from './seoFlightResult'
import { Box } from '@mui/material'

const SeoFlightResultWrapper = () => {
    return (
        <Box component="section" aria-label="Flight results">
            <SeoFlightResult />
        </Box>
    )
}

export default SeoFlightResultWrapper
